export default "__VITE_ASSET__CzG7mE6s__"